interface BangToken {
  /** Bang name, lowercased, without `!` or modifiers. */
  name: string;
  /** Modifiers in the order written, lowercased. */
  mods: string[];
  /** The token exactly as typed, e.g. `!eb.fs.$50-200`. */
  raw: string;
}

export interface SplitQuery {
  bang?: BangToken;
  /** Query text with the bang token removed. */
  terms: string;
}

const BANG = /(^|\s)!([^\s!]+)(?=\s|$)/;

/**
 * Pulls the first `!bang` token out of a raw query. The bang can sit anywhere
 * in the query; DuckDuckGo-style `cats !yt` works the same as `!yt cats`.
 */
export function splitQuery(raw: string): SplitQuery {
  const m = BANG.exec(raw);
  if (!m) return { terms: raw.replace(/\s+/g, ' ').trim() };
  const raw_ = `!${m[2]}`;
  const [name = '', ...mods] = (m[2] ?? '').toLowerCase().split('.');
  const start = m.index + (m[1] ?? '').length;
  const terms = `${raw.slice(0, start)} ${raw.slice(start + raw_.length)}`
    .replace(/\s+/g, ' ')
    .trim();
  return {
    bang: { name, mods: mods.filter(Boolean), raw: raw_ },
    terms,
  };
}

export function bangString(name: string, tokens: string[]): string {
  return `!${[name, ...tokens].join('.')}`;
}
